/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description ClaimTableActions
 */
import { ButtonProps, Dropdown, Tooltip } from 'antd';
import { MoreOne } from '@icon-park/react';
import { MenuItemType } from 'antd/es/menu/interface';
import Button from 'components/widgets/button';
import { getClaimActions } from 'utils/claims/claimState';

const defaultDropdownButtonProps: ButtonProps = {
	type: 'text',
	icon: null,
	style: { padding: 0, height: 'fit-content', width: '100%', justifyContent: 'flex-start' },
};

export interface IProps {
	claimId: string;
	workState: ClaimRequest.IClaimWorkState;
	previousWorkState: ClaimRequest.IClaimWorkState;
	claimResource: Fhir.Claim;
	pendingPR: number;
	isDraftPostAvailable: boolean;
}

const ClaimTableActions: React.FC<IProps> = ({ claimId, workState, previousWorkState, isDraftPostAvailable, claimResource, pendingPR }) => {
	const { changeWorkState } = getClaimActions({ workState, pendingPR, isDraftPostAvailable });

	const schema: MenuItemType[] = [
		changeWorkState.visible && {
			key: 'claimWorkState',
			className: 'tw-dropdown-menu-item',
			disabled: changeWorkState.disabled,
			label: (
				<Tooltip title={changeWorkState.tooltip}>
					<Button.ChangeClaimWorkState
						workState={workState}
						previousWorkState={previousWorkState}
						claimId={claimId}
						claimResource={claimResource}
						disabled={changeWorkState.disabled}
						{...defaultDropdownButtonProps}
					/>
				</Tooltip>
			),
		},
	];

	if (changeWorkState.visible) {
		return (
			<Dropdown menu={{ items: schema }} trigger={['click']} overlayClassName='claim-actions-dropdown'>
				<Button icon={<MoreOne />} onClick={(e) => e.stopPropagation()} />
			</Dropdown>
		);
	}
	return null;
};

export { defaultDropdownButtonProps };
export default ClaimTableActions;
